import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
  STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_FAILURE,
  STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_SUCCESS
} from '../constants'

export function* getStateMachineSaga({ data: { statusId } }) {
  try {
    const responseGetStateMachine = yield call(
      BFFAgent.Stock.TakingCarManagement.getStateMachine,
      statusId
    )

    if (responseGetStateMachine) {
      yield put({
        type: STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_SUCCESS,
        data: responseGetStateMachine
      })
    }
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_FAILURE,
      data: { error }
    })
  }
}
